var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpreader = function SvgSpreader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.287a1.72 1.72 0 0 0-1.715 1.715A1.72 1.72 0 0 0 10 11.718a1.72 1.72 0 0 0 1.715-1.716A1.72 1.72 0 0 0 10 8.287z",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.758 6.646v6.72c0 .834 1.01 1.253 1.6.662l3.36-3.36a.937.937 0 0 0 0-1.324l-3.36-3.36c-.59-.59-1.6-.172-1.6.662zm-9.504 0v6.72c0 .834-1.01 1.253-1.6.662l-3.36-3.36a.937.937 0 0 1 0-1.324l3.36-3.36c.59-.59 1.6-.172 1.6.662z"
  })));
};
export default SvgSpreader;